import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CheckpointInboxPage } from "@/features/checkpoints/pages/checkpoint-inbox-page";
import { requireFeatureEnabled } from "@/features/features";

// Direct deep-link /checkpoints/:id — renders inbox underneath with modal
// pre-opened for the given checkpoint ID. Inbox stays mounted; closing the
// modal navigates back to /checkpoints.
const checkpointIdSearchSchema = z.object({
  status: z.enum(["pending", "approved", "rejected", "expired", "cancelled"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_admin/checkpoints/$id")({
  beforeLoad: () => requireFeatureEnabled("workflows"),
  validateSearch: checkpointIdSearchSchema.parse,
  component: function CheckpointDetailRoute() {
    const { id } = Route.useParams();
    return <CheckpointInboxPage openCheckpointId={id} />;
  },
});
